import * as actions from "../../utils/Actions";

const initialState = {
  showPageLoader: false,
  downloadReceiptResponse:null,
  downloadFormResponse:null
};

export default function DashboardReducer(state = initialState, action) {
  if (typeof state === "undefined") {
    return state;
  }

  switch (action.type) {

    case actions.pending(actions.DOWNLOAD_RECEIPT):
      return {
        ...state,
        showPageLoader: true,
        downloadReceiptResponse:null
      };

    case actions.fulfilled(actions.DOWNLOAD_RECEIPT):
      return {
        ...state,
        showPageLoader: false,
        downloadReceiptResponse: action.payload.data,
      };

    case actions.rejected(actions.DOWNLOAD_RECEIPT):
      return {
        ...state,
        showPageLoader: false,
      };     
      
    case actions.pending(actions.DOWNLOAD_FORM):
      return {
        ...state,
        showPageLoader: true,
        downloadFormResponse:null
      };

    case actions.fulfilled(actions.DOWNLOAD_FORM):
      return {
        ...state,
        showPageLoader: false,
        downloadFormResponse: action.payload.data,
      };

    case actions.rejected(actions.DOWNLOAD_FORM):
      return {
        ...state,
        showPageLoader: false,
      };       
      
    default:
        return { ...state };
    }
}